// extracted by mini-css-extract-plugin
export var mediaTextAdvancedTeaserLayout = "NestedContentTeaser-module--mediaTextAdvancedTeaserLayout--f50cf";
export var teaserContainer = "NestedContentTeaser-module--teaserContainer--58e1c";